import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate'
})

export class TruncatePipe implements PipeTransform {

    transform(value: string, length: number): string {
        const ellipsis = '...';
        let result = value;
        if (value.length > length) {
            result = `${value.slice(0, length)}${ellipsis}`;
        }
        return result;
    }
}